// src/stripe/StripeContext.js
import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { useUserContext } from '../contexts/UserContext'; // Ajustez le chemin si besoin

const baseUrl = process.env.REACT_APP_API_URL; // ex. https://2awk5s869j.execute-api.eu-west-1.amazonaws.com/dev
const endpointCreateCheckout = `${baseUrl}/checkout-stripe-session`;

const baseUrlsite = window.location.origin;;
const successUrl = `${baseUrlsite}/success`;
const cancelUrl = `${baseUrlsite}/cancel`;

const StripeContext = createContext();

export const StripeProvider = ({ children }) => {
  const { tokens, userInfo } = useUserContext(); // on récupère le token d'accès
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Crée une session Stripe Checkout en appelant votre Lambda Python.
   * @param {string} priceId - L’ID du Price Stripe (mode Test) à facturer.
   * @param {number} quantity - La quantité (par défaut = 1).
   * @returns {Promise<string>} - L’URL de la session Stripe Checkout.
   */
  const createCheckoutSession = async (priceId, quantity = 1, mode = "payment") => {
    setLoading(true);
    setError(null);

    try {
      // 1) On vérifie qu'on a bien un token
      const token = tokens?.accessToken;
      if (!token) {
        throw new Error('Token manquant – vous devez être authentifié.');
      }

      // 2) Préparer le payload pour Stripe
      const payload = {
        priceId,
        quantity,
        mode,
        successUrl,
        cancelUrl,
        username: userInfo?.username || null
      };
      console.log('[StripeContext] 🛠️ Payload pour Stripe :', payload);

      // 3) Faire le POST vers /create-checkout-session
      const response = await axios.post(
        endpointCreateCheckout,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // 4) Vérifier le code HTTP
      if (response.status !== 200) {
        console.error('[StripeContext] ❌ Code non 200 :', response.status, response.data);
        throw new Error(response.data.error || 'Erreur lors de la création de la session Stripe');
      }

      // 5) Récupérer et renvoyer l'URL de Checkout
      const { sessionUrl } = response.data;
      if (!sessionUrl) {
        console.error('[StripeContext] ⚠️ Pas d’URL retournée :', response.data);
        throw new Error('Aucune URL de paiement reçue');
      }

      return sessionUrl;
    } catch (err) {
      console.error('[StripeContext] ❌ Erreur createCheckoutSession :', err);
      setError(err.message || 'Erreur inconnue');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return (
    <StripeContext.Provider value={{ createCheckoutSession, loading, error }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripeContext = () => useContext(StripeContext);
